import TablePage from '@/found/components/table_page';

export default {
  extends: TablePage,
  name: 'terminal_scan_in_record',
  data() {
    return {
      requestType: 'GET',
    };
  },
  async created() {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    const createStartTime = `${year}-${month}-${day} 00:00:00`;
    const createEndTime = `${year}-${month}-${day} 23:59:59`;
    this.searchFormData = {
      ...this.searchFormData,
      createStartTime,
      createEndTime,
    };
    await this.getConfigList('terminal_scan_in_record');
    this.formData = {
      ...this.formData,
      createStartTime,
      createEndTime,
    };
  },

  methods: {
    beforeSearchEvent({
      $event,
    }) {
      if ($event.type === 'reset') {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0');
        const day = String(today.getDate()).padStart(2, '0');
        const createStartTime = `${year}-${month}-${day} 00:00:00`;
        const createEndTime = `${year}-${month}-${day} 23:59:59`;
        this.searchFormData = {
          ...this.searchFormData,
          createStartTime,
          createEndTime,
        };
        this.formData = {
          ...this.formData,
          createStartTime,
          createEndTime,
        };
      }
      return true;
    },
  },
};
